import { FirebaseOptions, initializeApp } from "firebase/app";
import {
  connectAuthEmulator,
  initializeAuth,
  indexedDBLocalPersistence,
  setPersistence,
} from "firebase/auth";

const env = import.meta.env;

const config: FirebaseOptions = {
  apiKey: env.REACT_APP_API_KEY,
  appId: env.REACT_APP_APP_ID,
  authDomain: env.REACT_APP_AUTH_DOMAIN,
  databaseURL: env.REACT_APP_FIRESTORE_URL,
  measurementId: env.REACT_APP_MEASUREMENT_ID,
  messagingSenderId: env.REACT_APP_MESSAGING_SENDER_ID,
  projectId: env.REACT_APP_PROJECT_ID,
  storageBucket: env.REACT_APP_STORAGE_BUCKET,
};

if (env.REACT_APP_AUTH_DOMAIN?.includes("localhost")) {
  delete config.authDomain;
}

export const _firebase = initializeApp(config);

/**
 * auth setup
 */
// Redirect support is passed explicitly by SSO callers. Plain visits should not
// initialize Google's cross-origin iframe before the sign-in form can paint.
export const auth = initializeAuth(_firebase, {
  persistence: indexedDBLocalPersistence,
});
if (env.REACT_APP_AUTH_DOMAIN?.includes("localhost")) {
  connectAuthEmulator(auth, env.REACT_APP_AUTH_DOMAIN, {
    disableWarnings: true,
  });
}
export const authPersistenceReady = setPersistence(
  auth,
  indexedDBLocalPersistence,
);
// Consumers await this promise and surface initialization failures.
void authPersistenceReady.catch(() => {});
